// Service types a user can add/remove for a dealer, either from the dealer
// detail page (ServicesCard) or Bulk Update Dealers. "Sales"/"Service" are
// the two feed-owned base types every dealer is expected to have and can
// never be added or removed — mirrors backend ADDABLE_SERVICE_TYPES (models.py).
export const ADDABLE_SERVICE_TYPES = ["UsedCarSales", "SalesOthers", "Others2Service", "HeavyCrashPartners"];
